// Activity belongs to an assignment, not merely to a recipe or an old calendar date.
export function businessDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = name => parts.find(item => item.type === name).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function isShoppingAssignmentActive(meal, today) {
  return !!meal && meal.shopping_active === true && !!meal.meal_type &&
    String(meal.date || '').slice(0, 10) >= today;
}

export function shoppingAssignmentForRecipe(meals, today) {
  const future = (meals || []).filter(meal => String(meal.date || '').slice(0, 10) >= today)
    .slice().sort((a, b) => String(a.date).localeCompare(String(b.date)) || String(a.id).localeCompare(String(b.id)));
  return future.find(meal => isShoppingAssignmentActive(meal, today)) || future[0] || {};
}
